<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="trailersLimit"
				textCreate="Add trailer"
				:flag="flag"
				page-title="Trailers"
				:headers="headers"
				:settings="getSettings"
				:filtersList="trailersFilters"
				:list="trailersList"
				:defaultOrder="trailersOrder"
				:defaultSort="trailersSort"

				:totals="trailersTotals"
				:total-pages="trailersTotal"
				:limit-pages="trailersLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateEdit="onEdit"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				@updateCounter="onCounter"
				isExport
				is-create
				:permissionsCreate="permissionsCreate()"
				is-settings
		></main-table-all-back>

		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('trailers')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
		></remove-block>

		<comments-popup
				v-if="isCommentsPopup"
				:commentsList="commentsList"
				:commentsData="commentsData"
				@updateCloseComments="onCloseComments"
		></comments-popup>

		<trailers-form
				v-if="isTrailersForm"
				:trailerId="trailerId"
				:permissions="permissions"
				@updateClose="onCloseDialog"
		></trailers-form>
	</div>
</template>

<script>
// components
import TrailersForm from "@/components/Maintenance/Trailers/TrailersForm/TrailersForm";
import commentsPopup from "@/components/Fleet/WorkOrders/CommentsPopup/CommentsPopup";
// shared
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
import { mapActions, mapGetters } from "vuex";
import { FILTER_KEYS, PAGE, PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "Trailers",
	mixins: [ settingsMixins, removeMixins ],
	components: { commentsPopup, MainTableAllBack, TrailersForm },
	computed: mapGetters([
		"trailersList",
		"trailersFilters",
		"trailersTotals",
		"permissions",
		"trailersOrder",
		"trailersLimit",
		"trailersSort",
		"trailersTotal",
		"previewLink",
		"permissionsDefault",
	]),
	data: () => ({
		flag: PAGE.TRAILERS,
		isCommentsPopup: false,
		isTrailersForm: false,
		defaultFilter: null,
		activeTableFilters: null,
		trailerId: null,
	}),
	methods: {
		...mapActions([
			'getTrailers',
			'getTrailersFilters',
			'actionPreloader',
			'onExportLink',
			'onTrailersRemoveItem',
			'getTrailersComments'
		]),
		permissionsCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.MAINTENANCE, PERMISSIONS.TRAILERS, PERMISSIONS.CREATE ];
			return !getPermissionsMod({ list, path });
		},
		onCounter(args) {
			const { flag, line } = args;
			if (flag === FILTER_KEYS.DESCRIPTION) {
				const { id, trailer_number, trailer_type } = line;
				this.onCommentsPopup({ id, unit: trailer_number, unit_type: trailer_type });
			}
		},
		async onCommentsPopup({ id, unit, unit_type }) {
			this.commentsData = { unit, unit_type };
			this.commentsList = await this.getTrailersComments(id);
			this.isCommentsPopup = true;
			this.actionPreloader(false);
		},
		onCloseComments() {
			this.isCommentsPopup = false;
		},
		onCloseDialog(isRefresh) {
			this.isTrailersForm = false;
			if (isRefresh) {
				this.onUpdateFilters(this.defaultFilter);
			}
		},
		async onRemoveItem() {
			const { status } = await this.onTrailersRemoveItem(this.removeId);
			if (status) this.isRemove = false;
			await this.onUpdateFilters(this.defaultFilter);
		},
		async onEvent(flag) {
			if (flag === 'create') {
				this.isTrailersForm = true;
				this.trailerId = null;
			}
		},
		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getTrailers(filters);
			if (!isWithoutFilters) await this.getTrailersFilters(filters);
		},
		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getTrailers(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true); // без filters
					break;

				default:
					await this.onUpdateFilters(value); // ✅ с filters
			}
		},

		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'trailers' });
		},
		async onClickButton({ key, item }) {
			if (key === 'edit') {
				if (this.permissions[PERMISSIONS.EDIT]) {
					this.trailerId = item.id;
					this.isTrailersForm = true;
				}
			}

			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.id);
				}
			}
		},
		onEdit({ line }) {
			if (this.permissions[PERMISSIONS.EDIT]) {
				this.trailerId = line.id;
				this.isTrailersForm = true;
			}
		},
	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>
